import { useEffect, useContext } from 'react';
import {reducer} from "../../../context/"
import actionType from "../../../context/actionType";

/**
 * AuthLoader will check URL for search param ?auth=xxx
 * and set auth value to session storage if it exists.
 * 
 * Intended for use in login landing screen when user creates
 * account and is redirected back in order to re-load token.
 * 
 * TODO: extract auth loading useEffect from name plaque and asset wrapper to this component
 * TODO optimise checking and loading, refactor re-used code
 * TODO use case where auth is expired
 * 
 */
function AuthLoader() {
    // const { formReducer, configReducer } = useContext(reducer);
    useEffect(() => {
        // Case 1: Load auth from sessionStorage if it exists
        const auth = sessionStorage.getItem('auth')
        if(!!auth) {
            return; // do nothing
        }
        // Case 2: Get from URL
        const searchParams = new URLSearchParams(document.location.search);
        if(searchParams.has('auth') && !!searchParams.get('auth')) {
            sessionStorage.removeItem('auth');
            sessionStorage.removeItem('SAVED_FORM_DETAILS');
            sessionStorage.setItem('auth', searchParams.get('auth'));
            return;
        }
    }, []);
    return null;
}

export default AuthLoader;